/**
 * Class description
 *
 * Created: 2020-07-08
 * @author Jie
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class NearWinView extends BaseView {
    private _layer: PIXI.Container;
    private _activeReelId: number;
    private _spinStopped:boolean = false;
    private _nearWinBGs: TimelineSprite[];

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardGameConfig.instance.LAYERS.REEL_ATTENTION.name);
    }

    protected initAnimations(): void {
        this._nearWinBGs = ArrayHelper.initArrayWithValues(WinterHoardGameConfig.instance.REELS_NUM, (i: number) => {
            return this.createBG(i);
        });
        this._layer.addChild(this);
    }

    private createBG(i: number): TimelineSprite {
        const bg: TimelineSprite = new TimelineSprite(GameResources.getTextures("reelNearWin"));
        bg.blendMode = PIXI.BLEND_MODES.ADD;
        bg.hide();
        bg.anchor.set(0.5, 0.5);
        bg.position.set(Helper.getSymbolPositions(i, 0)[0] - (i * 12), Helper.getSymbolPositions(i, 1)[1]);
        this.addChild(bg);
        return bg;
    }

    public onSpinStart(){
        this._spinStopped = false;
    }

    public playOnReel(reelId: number, scatterPositions: number[]): void {
        if(this._spinStopped){
            return;
        }
        this.hide(reelId - 1);
        this._activeReelId = reelId;
        this._nearWinBGs[reelId].alpha = 1;
        this._nearWinBGs[reelId].show();
        this._nearWinBGs[reelId].playLoop();
        scatterPositions.forEach((pos: number, i: number) => {
            const sym:StateReelSymbol = Reels.getSymbol(i, pos)!;
            if (i <= reelId && pos > -1 &&(sym.currentState!.keyword !== WinterHoardGameConfig.instance.SYMBOL_STATES.plus.keyword)) {
                sym.changeState({
                    state: WinterHoardGameConfig.instance.SYMBOL_STATES.plus
                });
            }
        });
    }

    public hide(reel: number): void {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(this._nearWinBGs[reel], 0.3, {alpha: 0}));
        timeline.add(() => {
            this._nearWinBGs[reel].hide();
            this._nearWinBGs[reel].stopLoop();
        });
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this.scale.set(0.91, 0.91);
            this.y = 30;
            this.x = 37;
        } else {
            this.scale.set(0.99, 0.99);
            this.y = 40;
            this.x = 0;
        }
    }

    public forcedReset(): void {
        //debugger;
        this._nearWinBGs.forEach((bg: TimelineSprite, i: number) => {
            bg.stopLoop();
            bg.hide();
        });
    }

    public resetOnReel(reelId:number): void {
        //debugger;
        this._nearWinBGs[reelId].stopLoop();
        this._nearWinBGs[reelId].hide();
        /*this._nearWinBGs.forEach((bg: TimelineSprite, i: number) => {
            bg.stopLoop();
            bg.hide();
        });*/
    }

    public reset(scatterPositions: number[], singleWin: number, spinStopped:boolean = false): void {
        this._spinStopped = spinStopped;
        this._nearWinBGs.forEach((bg: TimelineSprite, i: number) => {
            bg.stopLoop();
            bg.hide();
        });
        if (singleWin <= 0) {
            scatterPositions.forEach((pos: number, i: number) => {
                if (pos > -1) {
                    Reels.getSymbol(i, pos)!.changeState({
                        state: WinterHoardGameConfig.instance.SYMBOL_STATES.normal
                    })
                }
            });
        }
    }
}